module.exports = __webpack_public_path__ + "static/media/photo-3.6920688d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/hall-farm-threshing-barn/photo-3.jpg
// module id = 162
// module chunks = 0